/**
 @ngdoc service
 @name mapCandidatesubmissionTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapCandidatesubmissionTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data
            if(rawTileData.itemCorporateURI){
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkBusinessModelField('jobId', 'itemPrincipleURI', 'itemCorporateURI'));
            }
            else {
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('jobId','itemPrincipleURI'));
            }
            let candidateName;
            if(rawTileData.candidateFirstName){
                candidateName = rawTileData.candidateFirstName + ' ' + rawTileData.candidateLastName;
            }
            if(tileFactory.isPrincipal()) {
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkJoinField('candidateFirstName', 'candidateLastName', 'candidateURI'));
            }
            else{
                tileFactory.addFieldToColumn1({label: objectTilesLabels.candidateFirstName.label, value: candidateName});
            }

            if (rawTileData.mobileOptout) {
                tileFactory.addFieldToColumn1(
                    tileFactory.field.newInactiveField('mobile', 'mobileOptout', 'mobileOptout','actionLogURI'));
            }
            else{
                tileFactory.addFieldToColumn1(
                    tileFactory.field.newInactiveField('mobile','unsubscribedFromCalls', 'unsubscribedFromCalls', 'actionLogURI'));

            }
            if (rawTileData.candidatecurrentPreviousJobTitle) {
                tileFactory.addFieldToColumn1(tileFactory.field.newField('candidatecurrentPreviousJobTitle'));
            }

            if(rawTileData.submittedNoticePeriodType.id) {
                tileFactory.addFieldToColumn1(tileFactory.field.newValueAndTypeField('submittedNoticePeriod', 'submittedNoticePeriodType'));
            }
            else
            {
                tileFactory.addFieldToColumn1({label: objectTilesLabels.submittedNoticePeriod.label, value: ""});
            }
            tileFactory.addFieldToColumn2(tileFactory.field.newField('title'));
            tileFactory.addFieldToColumn2(tileFactory.field.newField('orderTitle'));

            let hiringManager;
            if(rawTileData.hiringManagerFirstName){
                hiringManager = rawTileData.hiringManagerFirstName + ' ' + rawTileData.hiringManagerLastName;
            }
            if(tileFactory.isPrincipal()) {
              tileFactory.addFieldToColumn2(tileFactory.field.newField('branch'));
              tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationFieldWithLink('procurerOrgUnitName', 'procurerOrgName', 'businessURI'));
              tileFactory.addFieldToColumn2(tileFactory.field.newLinkJoinField('hiringManagerFirstName', 'hiringManagerLastName', 'hiringManagerURI'));


            }else{
                tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationField('procurerOrgUnitName', 'procurerOrgName'));
                tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationField('supplierOrgUnitName','supplierOrgName'));
                tileFactory.addFieldToColumn2({label: objectTilesLabels.hiringManagerFirstName.label, value: hiringManager});
            }

            if (rawTileData.town) {
                tileFactory.addFieldToColumn2(tileFactory.field.newAddressField('town'));
            }
            tileFactory.addFieldToColumn3(tileFactory.field.newRatePerUnitFieldLite('submittedPay','payType'));

            tileFactory.addFieldToColumn3(tileFactory.field.newField('taxStatus'));
            if (rawTileData.submittedPayWarning) {tileFactory.addFieldToColumn3(tileFactory.field.newField('submittedPayWarning'));}

            tileFactory.addFieldToColumn3(tileFactory.field.newLinkField('retrieveJobPostingText', 'retrieveJobPostingURI'));
            var applicationQuestions;
            if(rawTileData.applicationsAwaitingReviewURI){
                applicationQuestions = rawTileData.retrieveCorrectAnswerCount + ' / ' + rawTileData.retrieveQuestionCount;
            }
            if(rawTileData.jobPostingId && rawTileData.applicationsAwaitingReviewURI) {
                tileFactory.addFieldToColumn3({
                    label: objectTilesLabels.applicationsAwaitingReviewURI.label,
                    value: applicationQuestions,
                    link: rawTileData.applicationsAwaitingReviewURI
                });
            }
            tileFactory.addFieldToColumn3(
                tileFactory.field.newStarRatingField(
                  'score',
                  'scoreInfo',
                  'scoreNoMatch',
                  'findScoreDetailForJobURI'
                )
            );
            if(rawTileData.submittedDate) {
                tileFactory.addFieldToColumn4(tileFactory.field.newField('submittedDate', 'dateTime'));
            }
            if(!tileFactory.isPrincipal()) {
                tileFactory.addFieldToColumn4(tileFactory.field.newTimeField('timeFromDistributionToSubmission'));
            }
            tileFactory.addFieldToColumn4(tileFactory.field.newField('reason'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('submittedAvailableDate', 'date'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('withdrawalReason'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('applicantLastEmailed', 'date'));
            // tileFactory.addFieldToFullWidthRow(tileFactory.field.newField('orderTitle'));


            if(rawTileData.comments){
                tileFactory.addTextField(tileFactory.textField.newTextField('comments'));
            }

            if(rawTileData.attributeStatusIndicator) {
                tileFactory.addStageCollection(tileFactory.stageCollection.newStageCollection('attributeStatusIndicator'));
            }

            if(rawTileData.showCV) {
                tileFactory.addCallToAction(tileFactory.callToAction.newCallToActionModal('defaultCV', 'defaultCVURI'));
            }

            // Adding status

            // 642: "Shortlist"
            // 643: "Open"
            // 644: "Withdrawn"
            // 645: "Rejected"
            // 646: "Closed"
            // 5354: "Candidate Application"
            // 5356: "In Review"
            // 5357: "Booked"
            // 5358: "Interview"
            // 5384: "Application Rejected"
            // 5529: "Prospective"
            // 5922: "Application Shortlisted"

            tileFactory.addStatus(tileFactory.status.newStatus('submissionStatus',
                [
                    tileFactory.LOOKUP_VALUE.CANDIDATE_SUBMISSION_INTERVIEW,
                    tileFactory.LOOKUP_VALUE.CANDIDATE_SUBMISSION_BOOKED
                ],
                [
                    tileFactory.LOOKUP_VALUE.CANDIDATE_SUBMISSION_REJECTED,
                    tileFactory.LOOKUP_VALUE.CANDIDATE_SUBMISSION_APPLICATION_REJECTED,
                    tileFactory.LOOKUP_VALUE.CANDIDATE_SUBMISSION_WITHDRAWN,
                    tileFactory.LOOKUP_VALUE.CANDIDATE_SUBMISSION_CLOSED
                ],
                [
                    tileFactory.LOOKUP_VALUE.CANDIDATE_SUBMISSION_CANDIDATE_APPLICATION,
                    tileFactory.LOOKUP_VALUE.CANDIDATE_SUBMISSION_IN_REVIEW,
                    tileFactory.LOOKUP_VALUE.CANDIDATE_SUBMISSION_SHORTLIST,
                    tileFactory.LOOKUP_VALUE.CANDIDATE_SUBMISSION_OPEN,
                    tileFactory.LOOKUP_VALUE.CANDIDATE_SUBMISSION_APPLICATION_SHORTLISTED
                ]
            ));

            tileFactory.addStatus(tileFactory.status.newStatus('milestone'));

            if(rawTileData.offerStatus){
              tileFactory.addStatus(tileFactory.status.newStatus('offerStatus'));
            }
            // If Duplicate & Potential Duplicate both are set then only show Duplicate label
            if(rawTileData.duplicate== "Duplicate"){
                tileFactory.addStatus(tileFactory.status.newStatus('duplicate'));
            }else if(rawTileData.potentialDuplicate== "Potential Duplicate"){
                tileFactory.addStatus(tileFactory.status.newStatus('potentialDuplicate'));
            }

            if(rawTileData.candidateStatus.id == tileFactory.LOOKUP_VALUE.AVAILABILITY_STOPPED){
                tileFactory.addStatus(tileFactory.status.newStatusWithInfoAndStyling('candidateStatus', 'candidateStatusHelpText',
                    [],[tileFactory.LOOKUP_VALUE.AVAILABILITY_STOPPED],[]));
            }

            tileFactory.tileData.flagData = {
                link: rawTileData.rgaURI,
                status: lookupValues.rgaStatus[rawTileData.rgaValue]
            };



            return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapCandidatesubmissionTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapCandidatesubmissionTileService', mapCandidatesubmissionTileService);
}());
